<template>
  <div class="QS420-progress-page">
    <reviewProgress            
      :isShowPrev="isShowPrev"
      :isShowNext="isShowNext" 
    ></reviewProgress>
  </div>
</template>
<script>
import reviewProgress from "../../../pages/progress/progress.vue";
export default {
  components: {reviewProgress},
  props:["isShowPrev", "isShowNext"],
  methods: {
    pageActivated (_this){
      _this.hideFooter();
    },
    validate (_this) {
      let that = _this.$refs.QS420_uploadImg;
      return that.$refs.uploadImgView.validate().then(flag=>{
        return flag;
      });
    },
    //下一步时，保存数据.
    beforeSave (_this, params, baseData) {
     
    },
    next () {
      // this.$emit("on-next-click");
    }
  }
};
</script>
<style lang="less" scoped>
.QS420-progress-page {
  width: 14.9rem;

}
</style>


// WEBPACK FOOTER //
// src/business/businessFile/QS420/QS420_progress.vue